import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { TikTokIcon } from './TikTokIcon';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-152">
          <div data-id="element-153">
            <h3 className="text-2xl font-bold mb-6" data-id="element-154">She Wins</h3>
            <p className="text-gray-400 mb-6" data-id="element-155">
              Empowering women to become whole, wise, and victorious in every
              area of life through faith and community.
            </p>
            <div className="flex space-x-4" data-id="element-156">
              <a href="https://www.instagram.com/shewins_intlministry?igsh=MXh2aGU3eWNqaXluaw==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200" aria-label="Instagram" data-id="element-157">
                <Instagram size={20} data-id="element-158" />
              </a>
              <a href="https://www.facebook.com/share/1DAUTFBUTy/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200" aria-label="Facebook" data-id="element-159">
                <Facebook size={20} data-id="element-160" />
              </a>
              <a href="https://youtube.com/@shewinsintlministry?si=IFQ2JNaBdLNMRnNI" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200" aria-label="Youtube" data-id="element-161">
                <Youtube size={20} data-id="element-162" />
              </a>
              <a href="https://www.tiktok.com/@shewins_intlministry?_r=1&_t=ZS-91OdsttK9bB" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200" aria-label="TikTok" data-id="element-163">
                <TikTokIcon size={20} data-id="element-164" />
              </a>
            </div>
          </div>

          <div data-id="element-165">
            <h3 className="text-xl font-bold mb-6" data-id="element-166">Quick Links</h3>
            <ul className="space-y-3" data-id="element-167">
              <li data-id="element-168">
                <a href="#home" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-169">
                  Home
                </a>
              </li>
              <li data-id="element-170">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-171">
                  About Us
                </a>
              </li>
              <li data-id="element-172">
                <a href="#programs" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-173">
                  Programs
                </a>
              </li>
              <li data-id="element-174">
                <a href="#blog" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-175">
                  Blog
                </a>
              </li>
              <li data-id="element-176">
                <a href="#media" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-177">
                  Media
                </a>
              </li>
              <li data-id="element-178">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-200" data-id="element-179">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-180">
            <h3 className="text-xl font-bold mb-6" data-id="element-181">Contact Info</h3>
            <div className="space-y-3 text-gray-400 mb-6" data-id="element-182">
              <p data-id="element-183">shewinsintlministry@gmail.com</p>
              <p data-id="element-184">09155020551</p>
              <p data-id="element-185">08115773583</p>
              <p data-id="element-186">
                19, Shipeolu Street, Elediye Bustop,
                <br data-id="element-187" />
                Onipan. Lagos Nigeria.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-gray-400" data-id="element-188">
          <p data-id="element-189">
            &copy; {currentYear} She Wins International Ministry. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}